import axios from 'axios';
const auth = axios.create({ baseURL : 'https://v1-csapi.compsoft.com.br:826' });   /// trocado de 9008 para 826 conexão segura https:
//const auth = axios.create({ baseURL : 'http://localhost:9008'});
export default auth;